module.exports = __webpack_public_path__ + "static/the-intelligent-investor-dbed7e4830f950150bf3acfffd4a1d7a.jpg";